$(function(){

  // 姓入力時にセイに自動補完
  $.fn.autoKana( '[name="enduser[username_sei]"]', '[name="enduser[userkana_sei]"]', { katakana : true } );
  // 名入力時にメイに自動補完
  $.fn.autoKana( '[name="enduser[username_mei]"]', '[name="enduser[userkana_mei]"]', { katakana : true } );

  //隠れてるカテゴリーを表示する。
  $( '.form-cat__more' ).click(function(){
    if($( '.form-cat--sub' ).is(':hidden') ){
      $( '.form-cat--sub' ).show();
      $( this ).closest( 'form-group' ).append( $( this ).clone( true ) );
      $( this ).html( '<span>閉じる</span>' );
    } else {
      $( '.form-cat--sub' ).hide();
      $( this ).html( '<span>もっとみる</span>' );
    }
  });

  // ブレークポイント
  var breakpoint = window.matchMedia( 'screen and (max-width: 896px)' );
  // モーダル表示フラグ
  var modal_view_flg = false;

  //多重送信制限
  $( '#user_conversion' ).submit(function(){
    $( '.topForm__btn' ).prop( 'disabled', true );
    $('.loading').fadeIn();	
  });

  //#user_conversion にマッチするformが存在するとき
  if ( $( 'form#user_conversion' ).length ) {
    modal_view_flg = true;

    if ( breakpoint.matches ) {
      history.pushState( 'modal-open', null, '' );
    }
  }

  // フォームの内容を変更したとき
  $( 'form#user_conversion' ).find( 'select, input, textarea' ).on( 'change', function() {
    alert_flg = true;
  });

  // フォームサブミット時はアラートださない
  $( 'form#user_conversion' ).find( '.cBtn__submit' ).on( 'click', function() {
    alert_flg = false;
  });

  //ページ離脱時にアラート
  $( window ).on( 'beforeunload', function() {
    if ( ! breakpoint.matches && alert_flg ) {
      return '';
    }
  });

  //モーダルを非表示
  $( '[data-action="modal-close"]' ).on( 'click', function() {
    $( '.modal' ).removeClass( 'is-active' );
    $( 'body' ).removeClass( 'is-modal-open' );
    modal_view_flg = false;
    return false;
  });
});


//////////////////
// WEBPACK FOOTER
// ./app/assets/javascripts/form/base.js
// module id = 4
// module chunks = 0 1